module.exports = __webpack_public_path__ + "img/ic-chevron-down-circle-outline.43bb67e0.svg";